// base_info_view 1 
import React, { useRef, useState, useEffect } from 'react'
import BaseSearch1 from './base_search_1'
const BaseInfoView1_1 = ({
    keywordPlaceholder = "關鍵字",
    defaultKeyword,
    conditionOptions = { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
    defaultConditions,
    advancedFields =[],
    defaultAdvancedValues,
    searchButtonText = '查詢',
    showConditionFilter = true,
    showAdvancedButton = true,
    onSearch = () => { },
    onKeywordChange = () => { },
}) => {

    return (<BaseSearch1
        keywordPlaceholder={keywordPlaceholder}
        defaultKeyword={defaultKeyword}
        conditionOptions={conditionOptions}
        defaultConditions={defaultConditions}
        advancedFields={advancedFields}
        defaultAdvancedValues={defaultAdvancedValues}
        searchButtonText={searchButtonText}
        showConditionFilter={showConditionFilter}
        showAdvancedButton={showAdvancedButton}
        onSearch={onSearch}
        onKeywordChange={onKeywordChange}
    />)
}
export default BaseInfoView1_1
